export class NgxPaginationConfig {
    id: string;
    itemsPerPage = 10;
    currentPage = 1;
    totalItems: number;
}